import { render, staticRenderFns } from "./import-file.vue?vue&type=template&id=02f70f28&scoped=true&"
import script from "./import-file.vue?vue&type=script&lang=js&"
export * from "./import-file.vue?vue&type=script&lang=js&"
import style0 from "./import-file.vue?vue&type=style&index=0&id=02f70f28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f70f28",
  null
  
)

export default component.exports